import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
import '../../../modules/companies/register-panels'
import { CompanyFullPage } from '../../../modules/companies/company-full-page'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
})

/** The full-page company record at /companies/:id. */
export const Route = createFileRoute('/_authed/companies/$companyId')({
  validateSearch: detailSearchSchema,
  component: CompanyDetailRoute,
})

function CompanyDetailRoute() {
  const { companyId } = Route.useParams()
  return <CompanyFullPage companyId={companyId} />
}
